module.exports = __webpack_public_path__ + "static/media/Daisy & Gareth Kitchen (19).b360fbdd.jpg";